
import { Component, OnInit, Output, EventEmitter, Inject, inject } from '@angular/core';
import { NavService, Menu } from '../../services/nav.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { FeatherIconsComponent } from '../feather-icons/feather-icons.component';
import { FormBuilder, FormGroup, FormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, PRIMARY_OUTLET, Router, RouterModule } from '@angular/router';
import { AuthService } from '../../../_services/auth/auth.service';
import { CustomizerService } from '@app/shared/services/customizer.service';
import { UserAuthDto } from '@app/shared/model/user.model';
import { CompanyProfileDto } from '@app/shared/model/company-profile.model';
import { ValidationConstants } from '@app/shared/utilities/constants';
import { passwordMatchValidator } from '@app/utilities/validators';
import { filter, map } from 'rxjs';

var body = document.getElementsByTagName("body")[0];

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule,FeatherIconsComponent,FormsModule ,RouterModule ,TranslateModule],
  providers:[TranslateService], 
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public currentLanguage: string = 'EN';
  companyCode!: string;
  user!: UserAuthDto;
  companyProfile!: CompanyProfileDto | null;
  public menuItems: Menu[];
  public items: Menu[];
  public searchResult: boolean = false;
  public searchResultEmpty: boolean = false;
  public openNav: boolean = false
  public right_sidebar: boolean = false
  public text: string;
  public elem:any;
  public isOpenMobile: boolean = false;
  changePasswordForm!: FormGroup;
  public layoutType: string = 'ltr';
  public breadcrumbs:any;
  public title : string
  @Output() rightSidebarEvent = new EventEmitter<boolean>();
  headerTitle: any;
  //router = inject(Router);
  header : any;
  constructor(
    private userauth: AuthService,
    public navServices: NavService,
    @Inject(DOCUMENT) private document: any,
    private translate: TranslateService,
    private customizer : CustomizerService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private activatedRoute: ActivatedRoute,
    private router: Router
    ) {
      this.route.paramMap.subscribe(params => {
        //this.companyCode = params.get('companyCode') || ''; 
        //localStorage.setItem('companyCode',this.companyCode)
      });
      const companyCode = localStorage.getItem('companyCode') || this.companyCode;
      this.header = {
        'CompanyCode': companyCode // Use companyCode as a header
      };

      this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }))
      .pipe(filter(route => route.outlet === PRIMARY_OUTLET))
      .subscribe((route:any) => {
        let snapshot = this.router.routerState.snapshot;
        let title = route.snapshot.data['title'];
        let headerTitle = route.snapshot.data['headerTitle'];
        let parent = route.parent.snapshot.data['breadcrumb'];
        let child = route.snapshot.data['breadcrumb'];
        this.breadcrumbs = {};
        this.title = title;
        this.headerTitle = headerTitle;
        if (child === 'Project') {
          child = "";
        }
        if (child === 'Dashboard') {
          child = "";
        }
        this.breadcrumbs = {
          "parentBreadcrumb": parent,
          "childBreadcrumb": child
        }
      });
      //this.gotoProfileSetting();
  }

  ngOnInit() {
    this.user = this.userauth.getCurrentUserValue() || ({} as UserAuthDto);
    let companyObj = localStorage.getItem('companyProfile');
    if (companyObj) {
      this.companyProfile = JSON.parse(companyObj);
    }
    this.initializeForm();
    this.elem = document.documentElement;
    this.navServices.items.subscribe(menuItems => {
      this.items = menuItems
    });
  }
    logout() {
    //this.authService.logout();
    // this.router.navigate(['/']);
    this.resetSecurityObject();
  }
  EditProfile()
  {
    
    this.router.navigate(['/users']);
  }
  
  ChangePassword()
  {
    //this.router.navigate(['/change_password']);
  }
  initializeForm(): void {
    this.changePasswordForm = this.fb.group(
      {
        oldPassword: ['', [Validators.required]],
        password: [
          '',
          [
            Validators.required,
            Validators.minLength(ValidationConstants.MIN_PASSWORD_LENGTH),
            Validators.maxLength(ValidationConstants.MAX_PASSWORD_LENGTH),
          ],
        ],
        confirmPassword: ['', Validators.required],
      },
      { validator: passwordMatchValidator }
    );
  }
  ngOnDestroy() {
    this.removeFix();
  }
  gotoProfileSetting() {
    
    this.router.navigate([`user/${this.user.employeeId ?? this.user.id}`], {
      queryParams: { isProfile: 'true' },
    });
  }
  resetSecurityObject(): void {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('bearerToken');
    localStorage.removeItem('odIjHu1fB0TQIK4QTNOm6A==');
    this.router.navigate(['/auth/sign-up']);

  }

  right_side_bar() {
    
    this.right_sidebar = !this.right_sidebar
    this.rightSidebarEvent.emit(this.right_sidebar)
  }

  collapseSidebar() {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar
  }

  openMobileNav() {
    this.openNav = !this.openNav;
  }

  public changeLanguage(lang: string) {
    this.translate.use(lang);
    if (lang === 'ar') {
      this.currentLanguage = 'AR';
      this.customizeLayoutType('rtl'); // Switch to RTL if Spanish is selected
    } else {
      this.currentLanguage = 'EN';
      this.customizeLayoutType('ltr'); // Switch to LTR for other languages
    }
  }
  customizeLayoutType(val:any) {
    this.customizer.setLayoutType(val)
    this.layoutType = val
  }

  searchTerm(term: any) {
    term ? this.addFix() : this.removeFix();
    if (!term) return this.menuItems = [];
    let items :any = [];
    term = term.toLowerCase();
    this.items.filter((menuItems:any) => {
      if (menuItems.title.toLowerCase().includes(term) && menuItems.type === 'link') {
        items.push(menuItems);
      }
      if (!menuItems.children) return false
      menuItems.children.filter((subItems:any) => {
        if (subItems.title.toLowerCase().includes(term) && subItems.type === 'link') {
          subItems.icon = menuItems.icon
          items.push(subItems);
        }
        if (!subItems.children) return false
        subItems.children.filter((suSubItems:any) => {
          if (suSubItems.title.toLowerCase().includes(term)) {
            suSubItems.icon = menuItems.icon
            items.push(suSubItems);
          }
        })

        return
      })
      this.checkSearchResultEmpty(items)
      this.menuItems = items
      return
    });
    return
  }

  checkSearchResultEmpty(items:any) {
    if (!items.length)
      this.searchResultEmpty = true;
    else
      this.searchResultEmpty = false;
  }

  addFix() {
    this.searchResult = true;
    body.classList.add("offcanvas");
  }

  removeFix() {
    this.searchResult = false;
    body.classList.remove("offcanvas");
    this.text = "";
  }


  SignOut(){}

  toggleFullScreen() {
    this.navServices.fullScreen = !this.navServices.fullScreen;
    if (this.navServices.fullScreen) {
      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen();
      } else if (this.elem.mozRequestFullScreen) {
        /* Firefox */
        this.elem.mozRequestFullScreen();
      } else if (this.elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.elem.webkitRequestFullscreen();
      } else if (this.elem.msRequestFullscreen) {
        /* IE/Edge */
        this.elem.msRequestFullscreen();
      }
    } else {
      if (!this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }
}
